import { z } from 'zod';
import { globalSearchSchema } from './search.schema';
import { COMMUNICATIONS_VIEWS } from '../types/communications-view.type';

const searchSchema = z.object({
  view: z.enum(COMMUNICATIONS_VIEWS).optional(),
  conversationId: z.number().optional(),
  contactId: z.number().optional(),
  funnelId: z.number().optional(),
  conversationExportFileId: z.string().optional(),
  conversationExportRequestId: z.string().optional(),
  phoneVersion: globalSearchSchema.shape.phoneVersion.default('v1' as const),
});

/** URL state accepted by the communications route. */
export const communicationsSearchSchema =
  globalSearchSchema.merge(searchSchema);
/** Parsed communications URL state. */
export type CommunicationsSearch = z.infer<typeof communicationsSearchSchema>;
